"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ExperimentProviderContext_1 = __importDefault(require("./ExperimentProviderContext"));
function useExperimentBucket(experiment) {
    var experiments = react_1.useContext(ExperimentProviderContext_1.default).experiments;
    var _a = experiments[experiment] || {}, _b = _a.isLoading, isLoading = _b === void 0 ? null : _b, _c = _a.assignedBucket, assignedBucket = _c === void 0 ? null : _c;
    return isLoading ? null : assignedBucket;
}
exports.default = useExperimentBucket;
